'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactAddonsCssTransitionGroup = require('react-addons-css-transition-group');

var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _react2.default.createClass({
  displayName: 'FadeTransition',

  propTypes: {
    appear: _react.PropTypes.bool,
    children: _react.PropTypes.node,
    className: _react.PropTypes.string,
    enter: _react.PropTypes.bool,
    leave: _react.PropTypes.bool
  },

  getDefaultProps: function getDefaultProps() {
    return {
      appear: false,
      enter: true,
      leave: true
    };
  },
  render: function render() {
    var _props = this.props,
        children = _props.children,
        className = _props.className,
        appear = _props.appear,
        enter = _props.enter,
        leave = _props.leave;


    return _react2.default.createElement(
      _reactAddonsCssTransitionGroup2.default,
      {
        className: (0, _classNames2.default)('fade-transition-container', className),
        transitionName: 'fade-transition',
        transitionAppear: appear,
        transitionEnter: enter,
        transitionLeave: leave,
        transitionAppearTimeout: 200,
        transitionEnterTimeout: 200,
        transitionLeaveTimeout: 200
      },
      children
    );
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-internal-components/static-1.4266/js/transition/FadeTransition.js
// module id = 1184
// module chunks = 2 3